if (!customElements.get('loading-curtain')) {
    class LoadingCurtain extends HTMLElement {

        constructor() {
            super();
            document.addEventListener('loading-curtain:show', this.show.bind(this));
            document.addEventListener('loading-curtain:hide', this.hide.bind(this));
        }

        show() {
            document.querySelector('.js-main-confirmation-loading-curtain')?.classList.remove('hidden');
            document.querySelector('body').classList.add('overflow-hidden');
        }

        hide() {
            document.querySelector('.js-main-confirmation-loading-curtain')?.classList.add('hidden');
            document.querySelector('body').classList.remove('overflow-hidden');
        }
    }

    customElements.define('loading-curtain', LoadingCurtain);
}